import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

export const DateFieldV2 = ({ label, value, disabled, onChange }) => {
    const ignoreKeyDown = (e) => {
        e.preventDefault()
    }

    return (
        <FormControl>
            <FormLabel>{label}</FormLabel>
            <DatePicker
                disabled={disabled}
                disablePast
                value={value}
                slotProps={{
                    textField: { onKeyDown: ignoreKeyDown, size: 'small' },
                }}
                onChange={onChange}
            />
        </FormControl>
    )
}
